import React from 'react'
import PropTypes from 'prop-types'

// 自作ユーティリティ・ツール
import * as def from '../define'
import makeInfoTable from '../makeInfoTable'
import { showMaintenanceDlg } from '../utils'

// Ajax
import { sendConfirmationMail, checkErrorCode } from '../webapi'

/**
 * 入力内容の確認 〜 メールアドレス確認用認証メール送信
 */
export default class InputConfirm extends React.Component {
  constructor(props) {
    super(props)
    this.mailAddress = ''
    this.mailValidationCode = ''
    this.moveNext = this.moveNext.bind(this)
    this.handleBtnRegisterClick = this.handleBtnRegisterClick.bind(this)
    this.handleBtnBackClick = this.handleBtnBackClick.bind(this)
    this.handleBtnCancelClick = this.handleBtnCancelClick.bind(this)
  }

  moveNext() {
    if (typeof this.props.callbacks.stepChange === 'function') {
      let info = Object.assign({}, this.props.info)
      info.mailValidationCode = this.mailValidationCode
      this.props.callbacks.stepChange(info, def.STEPS.AUTHENTICATION)
    }
  }

  handleBtnRegisterClick() {
    // メールアドレス確認のため、認証コードを記載したメールを送信
    this.props.callbacks.showMessage('WAIT', {})
    sendConfirmationMail(this.props.info.token, this.props.info.adminMailAddress)
      .then(
        function (obj) {
          this.props.callbacks.showMessage('', {})
          this.moveNext()
        }.bind(this)
      ).catch(
        function (err) {
          if (checkErrorCode(err, def.API_ERROR_CODE.MAINTENANCE)) {
            // メンテナンス中
            const endTime = err.response.body.maintenanceEndTime
            showMaintenanceDlg(this.props.callbacks.showMessage, endTime, true)
            return
          }

          this.props.callbacks.showMessage('', {})
          if (typeof this.props.callbacks.showMessage === 'function') {
            if (err.status === 400) {
              this.props.callbacks.showMessage('MSGBOX', { msgTitle: 'エラー', msgBody: JSON.parse(err.response.text).message, forceLogout: false })
            } else {
              this.props.callbacks.showMessage('APIERR', { forceLogout: false })
            }
          }
        }.bind(this)
      )
  }

  handleBtnBackClick() {
    if (typeof this.props.callbacks.stepChange === 'function') {
      this.props.callbacks.stepChange(this.props.info, def.STEPS.ENTRY_INPUT)
    }
  }

  handleBtnCancelClick() {
    if (typeof this.props.callbacks.logout === 'function') {
      this.props.callbacks.logout()
    }
  }

  render() {
    return (
      <div className='appContent'>
        <h1>登録内容の確認</h1>
        <div style={{ lineHeight: '2em', width: '90%', marginLeft: 'auto', marginRight: 'auto' }}>
          {makeInfoTable(this.props.info)}
          <button type='button' id='btnRegister' style={{ margin: '40px' }} onClick={this.handleBtnRegisterClick}>認証コードを送信</button>
          <button type='button' id='btnBack' style={{ margin: '40px' }} onClick={this.handleBtnBackClick}>戻　る</button>
          <button type='button' id='btnCancel' style={{ margin: '40px' }} onClick={this.handleBtnCancelClick}>中　止</button>
        </div>
      </div>
    )
  }
}

InputConfirm.propTypes = {
  info: PropTypes.object.isRequired,
  callbacks: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/pages/inputConfirm.js